/* eslint-disable no-underscore-dangle */

import { memo } from 'react';

import { CircularProgress, Stack } from '@mui/material';

import { useAppSelector } from 'hooks/store/useAppStore';
import { UseUndoRedoReturn } from 'hooks/useUndoRedo';

import { NodeHighlighter } from '../NodeHighlighter';
import {
    PagePreviewContainer,
    PreviewToolbar,
} from './PagePreviewControl.styled';
import { PreviewControls } from './PreviewControls';
import { PreviewWindow } from './PreviewWindow';

type PagePreviewControlProps = {
    undoRedoActions: UseUndoRedoReturn['2'];
    loading?: boolean;
    error?: boolean;
};

const PagePreviewControl = ({
    undoRedoActions,
    loading,
    error,
}: PagePreviewControlProps): JSX.Element | null => {
    const { selectedNode } = useAppSelector((state) => state.pageBuilder);

    const preview = useAppSelector((state) => state.pageBuilder.config);

    if (loading) {
        return (
            <Stack alignItems="center" justifyContent="center" sx={{ flex: 1 }}>
                <CircularProgress variant="indeterminate" />
            </Stack>
        );
    }

    if (!loading && error) {
        return (
            <Stack alignItems="center" justifyContent="center" sx={{ flex: 1 }}>
                При загрузке страницы что-то пошло не так...
            </Stack>
        );
    }

    return preview ? (
        <PagePreviewContainer>
            <PreviewToolbar>
                <PreviewControls undoRedoActions={undoRedoActions} />
            </PreviewToolbar>
            <div className="preview">
                <PreviewWindow preview={preview} />
            </div>
            <NodeHighlighter
                selectedNode={selectedNode?._key}
                key={selectedNode?._key}
            />
        </PagePreviewContainer>
    ) : null;
};

export const EditorPagePreviewControl = memo(PagePreviewControl);
